<template>
    <div class="c-algolia-search__form c-anzcor-search__form">
        
        <div class="c-algolia-search__field c-algolia-search__field--group">
            <label class="c-algolia-search__label">Which guidelines are you searching?</label>

            <span class="c-algolia-search__select-wrapper">
                <select
                    v-model="selectedGroup"
                    id="project-status"
                    class="c-algolia-search__select"
                    @change="search"
                >
                    <option value="">All</option>
                    <option
                        v-for="groupItem in groupPages"
                        :value="groupItem"
                        :key="groupItem"
                    >
                        {{ groupItem }}
                    </option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 10L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L6 10" stroke="black" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </span>
        </div>

        <div class="c-algolia-search__row">

            <div class="c-algolia-search__field c-algolia-search__field--keywords">
                <label class="c-algolia-search__label" for="keywords">Search by keywords</label>
                <input
                    v-model="searchText"
                    type="text"
                    class="c-algolia-search__input"
                    placeholder="Keywords"
                    v-on:keyup.enter="search"
                    v-on:input="inputSearchText"
                />
            </div>

            <div class="c-algolia-search__field c-algolia-search__field--sort">
                <label class="c-algolia-search__label" for="sort">Sort by</label>
                <span class="c-algolia-search__select-wrapper">

                    <select v-model="sort" id="sort" class="c-algolia-search__select" @change="search">
                        <option value="">Relevance</option>
                        <option value="dateDesc">Newest</option>
                        <option value="dateAsc">Oldest</option>
                    </select>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 17L5 7M7 16L5.35355 17.6464C5.15829 17.8417 4.84171 17.8417 4.64645 17.6464L3 16M12 4H21M12 12H18M12 20H14M12 8H20M12 16H16" stroke="black" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </span>                
            </div>

            <div class="c-algolia-search__footer">

                <button class="c-algolia-search__button" @click="search">
                    Search
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M19.25 19.25L15.3125 15.3125M17.5 9.625C17.5 13.9742 13.9742 17.5 9.625 17.5C5.27576 17.5 1.75 13.9742 1.75 9.625C1.75 5.27576 5.27576 1.75 9.625 1.75C13.9742 1.75 17.5 5.27576 17.5 9.625Z" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                
                <button class="c-algolia-search__reset" @click="resetSearchFilters">Reset</button>

            </div>

        </div>

        
    </div>
</template>


<script>
import { mapFields } from "vuex-map-fields";

export default {
    data() {
        return {};
    },
    components: {},
    mounted() {
        this.setStateBasedOnUrlParameters();

        if (!this.selectedGroup && this.groupPages.length > 0) {
            this.selectedGroup = this.groupPages[0];
        }
    },
    computed: {
        ...mapFields([
            "searchApp.state.loading",
            "searchApp.state.hasSearched",

            "searchApp.search.searchText",
            "searchApp.search.selectedGroup",
            "searchApp.search.sort",
            "searchApp.search.start",

            "searchApp.searchOptions.groupPages",
        ]),
    },
    watch: {},
    methods: {
        resetFilters() {
            this.sort = "";
        },
        inputSearchText() {
            // We want to reset the sort back to relevant on textchange
            this.sort = "";
        },
        //Set state of filters and search based on url parameters
        setStateBasedOnUrlParameters() {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);
            let shouldSearch = false;

            const paramNames = ["selectedGroup", "sort", "searchText"];

            //only set param if the param is present in the url otherwise leave as the default value
            for (const paramName of paramNames) {
                const paramValue = params.get(paramName);
                if (paramValue || paramValue === "") {                    
                    this[paramName] = paramValue;
                    shouldSearch = true;
                    // console.log("set params", paramName, paramValue);
                }
            }

            if (shouldSearch) {
                this.search();
            }
        },
        search() {
            this.start = 0;
            this.$store.dispatch("submitSearch");
        },
        resetSearchFilters() {
            this.$store.dispatch("resetSearch");
        },
    },
};
</script>

<style lang="scss"></style>
